// extracted by mini-css-extract-plugin
export var root = "CloseMenuButton-module--root--ba2f9";